import { defineAction } from '~/prix'
import { z } from 'zod'
import bullCreateAction from './bullCreate.action.json' with { type: 'json' }
import { bullObject } from '../bullObject'

const bullCreateDefinition = defineAction({
  ...bullCreateAction,

  input: bullObject
    .pick({
      id: true,
      name: true,
      breed: true,
    })
    .partial({
      id: true,
    }),
  output: z.object({ id: bullObject.shape.id }),
})

export default bullCreateDefinition
